import { type TooltipOptions } from 'primeng/api';

export const TOOLTIP_OPTIONS: TooltipOptions = {
  tooltipStyleClass: 'custom-p-tooltip',
  showDelay: 50,
};
